export default "__VITE_ASSET__224faf63__"